import React from 'react';

const defaultValues = {
  docName: '',
  docNameActivity: '',
  funds: [],
  fundsActivity: [],
  investors: [],
  typePickerBoard: false,
  typePickerDocument: false,
  investorsActivity: [],
  classifications: [],
  classificationsActivity: [],
  read: '',
  publishChecked: false,
  effectiveChecked: false,
  asOfDate: '',
  fromDate: '',
  toDate: '',
  period: '',
  classificationToggle: false,
  fundsToggle: false,
  investorsToggle: false,
  periodToggle: false,
  slicerChoices: [],
  initialGroup: [],
  activityFeedFromDate: 0,
  gridWidgetFilterState: {},
  setGridWidgetFilterState: (e) => {},
  setToDate: (e) => {},
  setFromDate: (e) => {},
  setPublishChecked: (e) => {},
  setEffectiveChecked: (e) => {},
  setAsOfDate: (e) => {},
  setDocName: (e) => {},
  setDocNameActivity: (e) => {},
  setFunds: (e) => {},
  setFundsActivity: (e) => {},
  setInvestors: (e) => {},
  setInvestorsActivity: (e) => {},
  setClassifications: (e) => {},
  setClassificationsActivity: (e) => {},
  setRead: (e) => {},
  setPeriod: (e) => {},
  setTypePickerBoard: (e) => {},
  setTypePickerDocument: (e) => {},
  setClassificationToggle: (e) => {},
  setFundsToggle: (e) => {},
  setInvestorsToggle: (e) => {},
  setPeriodToggle: (e) => {},
  setSlicerChoices: (e) => {},
  setInitialGroup: (e) => {},
  setActivityFeedFromDate: (e) => {},
  clearFilters: () => {},
  clearSlices: () => {},
  clearFiltersActivity: () => {},
  clearAllFilters: () => {},
  hasFilters: () => {
    return false;
  },
  hasActivityFilters: () => {
    return false;
  },
};

const FilterCtx = React.createContext(defaultValues);

export default FilterCtx;
